import {
    formattedCampaignHistoryChangeTimeGetterNoTzShift,
    FormattedMessageHeaderRenderer,
    gridCampaignHistoryChangeTimeGetterNoTzShift,
} from '../../../components';
import { normalizeColumnDefs } from '../../../utils';
import * as FIELDS from '../../fields';
import { CAMPAIGN_HISTORY_REPORT_ID } from './campaignHistoryReportId';

const hugeColumnMinWidth = 140;
const smallColumnDefaultWidth = 70;
const campaignHistoryReportColumnDefinition = [
    {
        headerName: FIELDS.CHANGE_TIME.label,
        headerValueGetter: FormattedMessageHeaderRenderer,
        headerComponentParams: FIELDS.CHANGE_TIME.headerComponentParams,
        field: FIELDS.CHANGE_TIME.field,
        cellRenderer: FIELDS.CHANGE_TIME.cellRenderer,
        valueGetter: gridCampaignHistoryChangeTimeGetterNoTzShift,
        csvValueGetter: formattedCampaignHistoryChangeTimeGetterNoTzShift,
    },
    {
        headerName: FIELDS.CAMPAIGN_HISTORY_CAMPAIGN_NAME.label,
        headerValueGetter: FormattedMessageHeaderRenderer,
        headerComponentParams: FIELDS.CAMPAIGN_HISTORY_CAMPAIGN_NAME.headerComponentParams,
        field: FIELDS.CAMPAIGN_HISTORY_CAMPAIGN_NAME.field,
        cellRenderer: FIELDS.CAMPAIGN_HISTORY_CAMPAIGN_NAME.cellRenderer,
        csvValueGetter: FIELDS.CAMPAIGN_HISTORY_CAMPAIGN_NAME.csvValueGetter,
        minWidth: hugeColumnMinWidth,
    },
    {
        headerName: FIELDS.ACTIVITY.label,
        headerValueGetter: FormattedMessageHeaderRenderer,
        headerComponentParams: FIELDS.ACTIVITY.headerComponentParams,
        field: FIELDS.ACTIVITY.field,
        cellRenderer: FIELDS.ACTIVITY.cellRenderer,
        valueGetter: FIELDS.ACTIVITY.valueGetter,
        csvValueGetter: FIELDS.ACTIVITY.csvValueGetter,
    },
    {
        headerName: FIELDS.ACTIVITY_DETAILS.label,
        headerValueGetter: FormattedMessageHeaderRenderer,
        headerComponentParams: FIELDS.ACTIVITY_DETAILS.headerComponentParams,
        field: FIELDS.ACTIVITY_DETAILS.field,
        cellRenderer: FIELDS.ACTIVITY_DETAILS.cellRenderer,
        valueGetter: FIELDS.ACTIVITY_DETAILS.valueGetter,
        csvValueGetter: FIELDS.ACTIVITY_DETAILS.csvValueGetter,
        minWidth: hugeColumnMinWidth,
    },
    {
        headerName: FIELDS.OLD_VALUE.label,
        headerValueGetter: FormattedMessageHeaderRenderer,
        headerComponentParams: FIELDS.OLD_VALUE.headerComponentParams,
        field: FIELDS.OLD_VALUE.field,
        cellRenderer: FIELDS.OLD_VALUE.cellRenderer,
        valueGetter: FIELDS.OLD_VALUE.valueGetter,
        csvValueGetter: FIELDS.OLD_VALUE.csvValueGetter,
        width: smallColumnDefaultWidth,
    },
    {
        headerName: FIELDS.NEW_VALUE.label,
        headerValueGetter: FormattedMessageHeaderRenderer,
        headerComponentParams: FIELDS.NEW_VALUE.headerComponentParams,
        field: FIELDS.NEW_VALUE.field,
        cellRenderer: FIELDS.NEW_VALUE.cellRenderer,
        cellRendererParams: {
            isBoldCell: true,
            customFromDetails: true,
        },
        valueGetter: FIELDS.NEW_VALUE.valueGetter,
        csvValueGetter: FIELDS.NEW_VALUE.csvValueGetter,
        width: smallColumnDefaultWidth,
    },
    {
        headerName: FIELDS.PERFORMER.label,
        headerValueGetter: FormattedMessageHeaderRenderer,
        headerComponentParams: FIELDS.PERFORMER.headerComponentParams,
        field: FIELDS.PERFORMER.field,
        cellRenderer: FIELDS.PERFORMER.cellRenderer,
        csvValueGetter: FIELDS.PERFORMER.csvValueGetter,
    },
];

export default normalizeColumnDefs(campaignHistoryReportColumnDefinition, CAMPAIGN_HISTORY_REPORT_ID);
